/**
 * abilityVfxSupportMeshes — Shape dispatch for SPY-312 support wave (OCP).
 */
import {
  buildStarcall,
  buildAstralInfusion,
  buildEquinox,
  buildWish
} from './abilityVfxSoraka.js';
import {
  buildGlitterlance,
  buildWhimsy,
  buildHelpPix,
  buildWildGrowth
} from './abilityVfxLulu.js';
import {
  buildAquaPrison,
  buildEbbAndFlow,
  buildTidecallerBlessing,
  buildTidalWave
} from './abilityVfxNami.js';

const SUPPORT_SHAPE_BUILDERS = {
  starcall: buildStarcall,
  astral_infusion: buildAstralInfusion,
  equinox: buildEquinox,
  wish: buildWish,
  glitterlance: buildGlitterlance,
  whimsy: buildWhimsy,
  help_pix: buildHelpPix,
  wild_growth: buildWildGrowth,
  aqua_prison: buildAquaPrison,
  ebb_and_flow: buildEbbAndFlow,
  tidecaller_blessing: buildTidecallerBlessing,
  tidal_wave: buildTidalWave
};

/** @returns {object|null} */
export function buildSupportAbilityMesh(THREE, spec) {
  const build = SUPPORT_SHAPE_BUILDERS[spec?.shape];
  return build ? build(THREE, spec) : null;
}
